import { OthersDocumentProps, REGEXP_DOCS } from '../DocumentationRequired.model';
import { SelectOptions } from '../../../ApisForm.model';
import { IconLinkButton } from '../../../../../navigation';
import { ControllerInputDateSelect, ControllerInputSelect, InputTextCleaner } from '../../../../../forms';
import clsx from 'clsx';
import { Divider } from '../../../../Divider';
import { Text } from '../../../../../foundations';
import { useOthersDocuments } from '../../../hooks/UseOthersDocuments';
import { useTranslation } from 'react-i18next';
import styles from '../DocumentationRequired.module.css';
import { DocOtherFields } from '../../../ApisForm.constants';
import { useEffect } from 'react';

export const OthersDocuments = ({ options, config, isInfant = false }: OthersDocumentProps) => {
	const { t } = useTranslation(['documentation-required', 'common']);
	const {
		isCollapsed,
		setCollapsed,
		requiredFields,
		marginCollapse,
		handleChangeType,
		minDate,
		maxDate,
		modelInfant,
		isFormDisabled = false,
		resetField
	} = useOthersDocuments({
		config,
		styles,
		options,
		isInfant
	});

	useEffect(() => {
		return () => {
			resetField(DocOtherFields.MODEL, undefined);
		};
	}, [isCollapsed]);

	return (
		<div className={styles.box_content}>
			{isCollapsed && (
				<div className={styles.box_content_section}>
					<div className={styles.box_title}>
						<Divider />
						<Text as="h4" font="iberia-headline" className={styles.box_title}>
							{t('TITLE_OTHERS_DOCUMENTS')} {t('common:OPTIONAL')}
						</Text>
					</div>
					{/* Select issuer country */}
					<div className={styles.box_input}>
						{requiredFields.issuerCountry && (
							<ControllerInputSelect
								name={`${modelInfant}${DocOtherFields.ISSUER_COUNTRY}`}
								label={t('DOCUMENT_COUNTRY')}
								options={options?.countries as SelectOptions[]}
								disabled={isFormDisabled}
							/>
						)}
					</div>
					{/* Select document type */}
					<div className={styles.box_input}>
						<ControllerInputSelect
							name={`${modelInfant}${DocOtherFields.TYPE}`}
							label={t('DOCUMENT_TYPE')}
							options={options?.otherDocsTypes as SelectOptions[]}
							onChange={(e) => {
								handleChangeType(e);
							}}
							disabled={isFormDisabled}
						/>
					</div>
					{/* Input num document */}
					<div className={styles.box_input}>
						{requiredFields.number && (
							<InputTextCleaner
								name={`${modelInfant}documentationRequired.other.number`}
								label={t('DOCUMENT_NUMBER')}
								regexCleaner={REGEXP_DOCS}
								maxLength={15}
								className={styles.box_input_text}
								labelStyles={styles.labelStyles}
								disabled={isFormDisabled}
							/>
						)}
					</div>
					{/* Select expiry date */}
					<div className={styles.box_input}>
						{requiredFields.expiryDate && (
							<ControllerInputDateSelect
								name={`${modelInfant}documentationRequired.other.expiryDate`}
								label={t('EXPIRY_DATE')}
								minDate={minDate}
								maxDate={maxDate}
								disabled={isFormDisabled}
							/>
						)}
					</div>
				</div>
			)}

			<div className={clsx([styles.input_link_btn, marginCollapse])}>
				<IconLinkButton
					button
					icon={isCollapsed ? 'no-disponible' : 'mas'}
					onClick={() => {
						setCollapsed((prevState) => !prevState);
					}}
				>
					{isCollapsed ? t('DELETE_DOCUMENT') : `${t('ADD_DOCUMENT')} ${t('common:OPTIONAL')}`}
				</IconLinkButton>
			</div>
		</div>
	);
};
